import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  const variantOptions = $(node).find('input[name^="option-"]')
  const handleOptionChange = ({ target }) => {
    const selectedOption = $(target)
    const variantId = Number(selectedOption.attr('value')) || ''
    const selling_plan = selectedOption.attr('data-selling-plan-id')
    const is_selling_plan = selectedOption.attr('data-is-selling-plan')

    if (is_selling_plan) {
      $('add-button').attr('data-selling-plan-id', selling_plan)
    }
    $('add-button').attr('data-variant-id', variantId)

    window.MicroBus.emit('igEvents:push', {
      event: `Scent Selector Changed - ${selectedOption.attr('data-handle')}`,
    })
    if (window?.gtag) {
      window?.gtag('event', 'Scent Selector Changed', {
        event_detail: selectedOption.attr('data-handle'),
      })
    }

    window.MicroBus.emit('variant:change', variantId)
  }

  window.MicroBus.on(`variant:change`, (e) => {
    updateSelectors(e)
  })

  const updateSelectors = (event) => {
    const currentVariantId = event.detail
    const currentProductId = window.allVariants.find((variant) => variant.id == currentVariantId)?.product_id
    const currentSelectedVariantOptions = window.allVariants.find((variant) => variant.id === currentVariantId)?.options
    const currentScentOptionIndex = window.product.options.findIndex((option) => option === 'Scent')
    let updateVariantId

    // set data-is-active-variant to false for all scent options
    $('[data-is-active-variant="true"]').each((option) => {
      $(option).attr('data-is-active-variant', 'false')
    })

    window.allVariants.forEach((variant) => {
      // match all options except scent
      let matchedOptions = true
      if (variant.options.length == 1) {
        matchedOptions = true
      } else {
        variant.options.forEach((option, index) => {
          if (index !== currentScentOptionIndex && option != currentSelectedVariantOptions[index]) {
            matchedOptions = false
          }
        })
      }

      if (matchedOptions == true) {
        $('input[name="option-scent"]').each((option) => {
          const parentDiv = $(option).parent().el()
          const isEnabledOnVariant = $(parentDiv).attr('data-is-enabled-on-variant')
          const optionVariantId = $(option).attr('data-variant-id')
          const optionProductId = $(option).attr('data-product-id')

          if (optionVariantId == variant.id && optionProductId == currentProductId) {
            $(parentDiv).attr('data-is-active-variant', 'true')
            $(parentDiv).removeClass('tw-hidden')
          }

          if ($(parentDiv).attr('data-is-active-variant') == 'false' && isEnabledOnVariant == 'false') {
            $(parentDiv).attr('data-is-active-variant', 'false')
          }

          if (
            optionVariantId == currentVariantId &&
            optionProductId == currentProductId &&
            isEnabledOnVariant == 'true' &&
            $(parentDiv).attr('data-is-active-variant') == 'true'
          ) {
            document.querySelector(`input[name="option-scent"][value="${$(option).attr('value')}"]`).checked = true
            $('#scent-variant-selector').removeClass('tw-hidden')
          } else if (isEnabledOnVariant == 'false' && $(parentDiv).attr('data-is-active-variant') == 'true') {
            // select the first scent option variant if the scent selector is disabled
            document.querySelector(`[data-is-active-variant="true"] input[name="option-scent"]`).checked = true

            updateVariantId = document
              .querySelector(`[data-is-active-variant="true"] input[name="option-scent"]`)
              .getAttribute('value')

            $('#scent-variant-selector').addClass('tw-hidden')
            $(parentDiv).removeClass('tw-hidden')
            return
          }
        })
      }
    })

    if (updateVariantId && updateVariantId != currentVariantId) {
      handleOptionChange({ target: document.querySelector(`[data-is-active-variant="true"] input[name="option-scent"]`) })
      event.stopImmediatePropagation()
    }
  }

  variantOptions.on('change', handleOptionChange)
  return () => variantOptions.off('change', handleOptionChange)
})
